import { createSelector } from "reselect";

const artisanPublicInquiriesStateSelector = (state) =>
	state.myArtisanPublicInquiries;

const selectById = (state, itemId) => itemId;

export const artisanPublicInquiriesSelector = createSelector(
	[artisanPublicInquiriesStateSelector],
	(inquiries) => inquiries.items
);

export const artisanProposalsSelector = createSelector(
	[artisanPublicInquiriesStateSelector],
	(inquiries) => inquiries.proposals
);

export const inquiryByIdSelector = createSelector(
	[artisanPublicInquiriesSelector, selectById],
	(inquiries, _id) => {
		console.log(inquiries);
		const inquiry = inquiries.find((item) => _id === item._id);
		if (!inquiry) return null;
		return inquiry;
	}
);

export const artisanPublicInquiriesIsLoadingSelector = createSelector(
	[artisanPublicInquiriesStateSelector],
	(inquiries) => inquiries.isLoading
);

export const artisanPulbicInquiriesSearchValue = createSelector(
	[artisanPublicInquiriesStateSelector],
	(inquiries) => inquiries.searchValue
);

export const artisanPublicInquiriesCount = createSelector(
	[artisanPublicInquiriesStateSelector],
	(inquiries) => inquiries.count
);

export const pendingArtisansPublicInquiryCountSelector = createSelector(
	[artisanPublicInquiriesStateSelector],
	(proposal) => proposal.proposalsCount
);
